class Main {
	constructor(modules, Utils) {
		this.utils = new Utils()
		this.moduleSelector = 'data-module'
		this.modulesOnPage = document.querySelectorAll(
			`[${this.moduleSelector}]`
		)
		this.modulesLoaded = []

		this.inIframe = () => {
			try {
				return window.self !== window.top
			} catch {
				return true
			}
		}

		this.loadModules = () => {
			/* dynamically import required modules */
			Array.from(this.modulesOnPage).forEach(element => {
				/* store name of module */
				let moduleInstance = element.getAttribute(this.moduleSelector)

				/* ensure module exists in our imports and that it's not already loaded */
				if (
					Object.keys(modules).indexOf(moduleInstance) !== -1 &&
					this.modulesLoaded.indexOf(moduleInstance) === -1
				) {
					this.modulesLoaded.push(moduleInstance)

					modules[moduleInstance]()
						.then(instance => {
							let instanceRef = new instance.default(this.utils)
							instanceRef.init()
						})
						.catch(err => {
							console.log(
								'An error occurred while loading the component ' +
									moduleInstance
							)
							console.error(err)
						})
				}
			})
		}
	}

	init() {
		console.log('Main Init')
		if (this.inIframe()) {
			console.log('(in iframe)')
			window.addEventListener('load', this.loadModules, false)
		} else {
			this.loadModules()
		}
	}
}

export default Main
